import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NavigationBar.css";
import { useAdmin } from "../../State/Context/AdminContext";

export const NavigationBar: React.FC = () => {
    const { adminMode } = useAdmin();
    const [isOpen, setIsOpen] = useState(false);
    const sidebarRef = useRef<HTMLDivElement>(null);
    const sidebarButtonRef = useRef<HTMLLabelElement>(null);

    const location = useLocation();

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const handleClickOutside = useCallback(
        (event: MouseEvent) => {
            if (
                sidebarRef.current &&
                sidebarButtonRef.current &&
                !sidebarRef.current.contains(event.target as Node) &&
                !sidebarButtonRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false);
            }
        },
        [sidebarRef]
    );

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handleClickOutside]);

    const linkClass = "hover:text-site-accent transition duration-300";
    const liClass = "md:flex md:items-center";

    const linkItems = (
        <>
            <li className={liClass}>
                <span
                    className={`text-site-accent text-2xl font-bold ${
                        location.pathname !== "/" && "opacity-0"
                    }`}
                >
                    •&nbsp;
                </span>
                <Link to="/" className={linkClass}>
                    home
                </Link>
            </li>
            <li className={liClass}>
                <span
                    className={`text-site-accent text-2xl font-bold ${
                        location.pathname !== "/gallery" && "opacity-0"
                    }`}
                >
                    •&nbsp;
                </span>
                <Link to="/gallery" className={linkClass}>
                    gallery
                </Link>
            </li>
            <li className={liClass}>
                <span
                    className={`text-site-accent text-2xl font-bold ${
                        location.pathname !== "/upcoming" && "opacity-0"
                    }`}
                >
                    •&nbsp;
                </span>
                <Link to="/upcoming" className={linkClass}>
                    upcoming
                </Link>
            </li>
            <li className={liClass}>
                <span
                    className={`text-site-accent text-2xl font-bold ${
                        location.pathname !== "/bio" && "opacity-0"
                    }`}
                >
                    •&nbsp;
                </span>
                <Link to="/bio" className={linkClass}>
                    bio
                </Link>
            </li>
            <li className={liClass}>
                <span
                    className={`text-site-accent text-2xl font-bold ${
                        location.pathname !== "/links" && "opacity-0"
                    }`}
                >
                    •&nbsp;
                </span>
                <Link to="/links" className={linkClass}>
                    links
                </Link>
            </li>
            {adminMode && (
                <li className={liClass}>
                    <span
                        className={`text-site-accent text-2xl font-bold ${
                            location.pathname !== "/admin" && "opacity-0"
                        }`}
                    >
                        •&nbsp;
                    </span>
                    <Link to="/admin" className={linkClass}>
                        admin
                    </Link>
                </li>
            )}
        </>
    );

    return (
        <nav className="bg-gray-950 text-white p-2 flex items-center justify-between relative z-50">
            <div className="p-4 font-bold text-xl">Luc Hoekx</div>
            <div className="md:hidden">
                <label ref={sidebarButtonRef} className="hamburger-menu p-5">
                    <input
                        type="checkbox"
                        checked={isOpen}
                        onChange={toggleOpen}
                    />
                </label>
            </div>
            <ul className="hidden md:flex md:space-x-4 p-4">{linkItems}</ul>

            {/* Floating Menu for Mobile */}
            {isOpen && (
                <aside
                    ref={sidebarRef}
                    className={`p-3 md:hidden sidebar ${
                        isOpen && "sidebar-open"
                    } bg-gray-950`}
                >
                    <div className="p-4 font-bold text-xl">Luc Hoekx</div>

                    <ul className="text-right px-5">{linkItems}</ul>
                </aside>
            )}
        </nav>
    );
};
